import { type CarouselNavigationButtonProps } from "./types/carousel-navigation-button.types";
import { IconButton } from "../icon-button";
import { IconChevronLeftSmall, IconChevronRightSmall } from "../../dds-ported-icons";

export const CarouselNavigationButton: React.FC<CarouselNavigationButtonProps> = (props) => {
  const { children: _children, action, ...rest } = props;

  return (
    <IconButton size="s" variant="stroke" aria-label={action === "prev" ? "Previous item" : "Next item"} {...rest}>
      {action === "prev" ? <IconChevronLeftSmall size="xs" /> : <IconChevronRightSmall size="xs" />}
    </IconButton>
  );
};
